import { cn, Image } from "@quint/ui";
import { type HTMLProps } from "react";
import QuintImage from "public/logos/quint-image.png";

export const LogoIcon = ({
  color,
  ...props
}: { color: string | "gradient" } & HTMLProps<HTMLDivElement>) => (
  <div
    className={cn(
      "flex h-[56px] w-[56px] items-center justify-center rounded-[28px]",
      {
        iconGradient: color === "gradient",
      }
    )}
    style={{ backgroundColor: color }}
    {...props}
  >
    <Image src={QuintImage} width={26} height={26} alt="quint logo" />
  </div>
);
